export default __webpack_public_path__ + "static/media/fortune-12.a9464849.png";